<template>
  <div>
    <div class="row">
      <div class="col-2">
        Week
        {{ selected_week_index + 1 }}
        of
        {{ combined_weeks_count }}
      </div>
      <div class="col-6">
        <div class="row">
          <div class="col-1">
            <button id="prev" @click="_prev" class="btn btn-plt">
              &lt;
            </button>
          </div>
          <div class="col-1">
            <button id="next" @click="_next" class="btn btn-plt">
              &gt;
            </button>
          </div>
        </div>
      </div>
    </div>
    <CombinedJobWeekDisplay class="col" />
    <JobCustomerSelection
      v-if="showNewRoundModal"
      @save="_save_new_job"
      @close="_close_round_popup"
      @delete="_close_round_popup"
      :schedule_round="round"
      :available_jobs="available_jobs"
      :copy_enabled="false"
    />
  </div>
</template>

<script>
import CombinedJobWeekDisplay from "@/components/job/CombinedJobWeekDisplay.vue";
import JobCustomerSelection from "@/components/job/JobCustomerSelection.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "ViewCombinedSchedule",
  data: () => ({
    round: null,
    showNewRoundModal: false,
    showEditScheduleModal: false,
    tab: 0,
  }),
  computed: {
    ...mapState("schedule", [
      "selected_week",
      "selected_week_start",
      "selected_week_end",
      "schedule_group_weeks",
      "available_jobs",
      "selected_week_index",
      "next_schedule_round_tmp_id",
      "combined_weeks_count",
    ]),
    ...mapState("status", ["round_to_copy"]),
  },
  methods: {
    ...mapActions("schedule", [
      "getSchedule",
      "saveSchedule",
      "nextTmpScheduleRoundId",
      "select_next_week",
      "select_previous_week",
    ]),
    ...mapActions("status", [
      "enable_job_dragging",
      "disable_job_dragging",
      "clear_copy_round",
    ]),
    mounted() {
      this._reset();
    },
    _loadWeek() {
      this.getSchedule();
    },
    _save() {
      this.saveSchedule();
    },
    _edit() {
      this._toggleEditScheduleModal();
    },
    _copy() {
      this._toggleShowCopyWeekModal();
    },
    _toggleEditScheduleModal() {
      this.showEditScheduleModal = !this.showEditScheduleModal;
    },
    _toggleShowCopyWeekModal() {
      this.showCopyWeekModal = !this.showCopyWeekModal;
    },
    _new_round() {
      this.nextTmpScheduleRoundId(),
        (this.round = {
          id: this.next_schedule_round_tmp_id,
          round: {
            id: 0,
            name: "",
            area: "",
            jobs: [],
            active: true,
            fixed: false,
          },
          active: true,
          day_index: -1,
          week_index: -1,
          vehicle_id: -1,
          vehicle: null,
          sequence_order: 1, // use count of rounds in that day
          schedule_id: this.schedule ? this.schedule.id : -1,
          personnels: [],
          round_id: 0,
        });
      this.disable_job_dragging();
      this.showNewRoundModal = true;
    },
    _reset() {
      this._loadWeek();
    },
    _close_round_popup() {
      this.showNewRoundModal = false;
      this.enable_job_dragging();
    },
    _save_new_job() {
      this.showNewRoundModal = false;
      this.enable_job_dragging();
    },
    _select_date() {},
    _next() {
      this.select_next_week();
    },
    _prev() {
      this.select_previous_week();
    },
  },
  components: {
    CombinedJobWeekDisplay,
    JobCustomerSelection,
  },
};
</script>
